import siteMixin from "@/mixins/siteMixin";
import userMixin from "@/mixins/userMixin";
import helperMixin from "@/mixins/helperMixin";
import { RRule } from "rrule";
export default {
    data: () => ({
        //token: '1hbnPuxxKguJe7HlgIHhIBeWvoVGgJrh',
        apiRoute: process.env.VUE_APP_HEYGOV_API.replace(/\/$/, ""),
        // apiRoute: "https://api.heygov.com",
        // apiRoute: "http://localhost:8080",
        // appRoute: "https://app.heygov.com",
        appRoute: process.env.VUE_APP_HEYGOV_APP,
        // appRoute: "http://localhost:8081",

        suffix: "venues?status=public",
        headers: null,
        controller: null,
        hasHeyGov: false,
        hasHeyGovEvents: false,
    }),
    methods: {
        async getHeyGovVenues() {
            let res = await this.axios.get(`${this.apiRoute}/${this.domain}/${this.suffix}`); // action additional param
            // let res = await this.axios.post(this.apiRoute + this.site + this.suffix, {token: this.token, action: 'subscriptionInfo' }); // action additional param
            if (res.status && res.status === 200) {
                return res.data;
            }
        },
        async heyGovJurisdiction() {
            if (this.domain) {
                let res = await this.axios.get(`${this.apiRoute}/${this.domain}`);
                let jurisdiction = res.data;
                let site = localStorage.getObject("site");
                if (jurisdiction) {
                    this.hasHeyGov = true;
                    if (jurisdiction?.features.includes("events") && !site.tribeEventsActive) {
                        this.hasHeyGovEvents = true;
                    } else {
                        this.hasHeyGovEvents = false;
                    }
                }
                if (this.getSiteType() == "cms6") {
                    this.hasHeyGovEvents = true;
                }
                return jurisdiction;
            }
        },
        // get human readable frequency from rrule options object or rrule string
        getFrequencyLabel(rruleInput) {
            // Now rrule is stored as options object
            if (typeof rruleInput === "object" && rruleInput.freq !== undefined) {
                // It's an options object - directly map frequency
                const freqLabels = {
                    [RRule.DAILY]: "Daily",
                    [RRule.WEEKLY]: "Weekly",
                    [RRule.MONTHLY]: "Monthly",
                    [RRule.YEARLY]: "Yearly"
                };
                return freqLabels[rruleInput.freq] || "Unknown";
            } else if (typeof rruleInput === "string") {
                // Backward compatibility for old string format
                if (rruleInput.includes("DTSTART") || rruleInput.includes("RRULE:")) {
                    const frequencyMatch = rruleInput.match(/FREQ=([A-Z]+)/);
                    if (frequencyMatch) {
                        const labels = {
                            "DAILY": "Daily",
                            "WEEKLY": "Weekly",
                            "MONTHLY": "Monthly",
                            "YEARLY": "Yearly"
                        };
                        return labels[frequencyMatch[1]] || "Unknown";
                    }
                }
            }
            return "Unknown";
        },
        // Do translation from old recurrence rules to new RRule format
        translateOldRecurrenceToRRule(event) {
            // old recurrence object example:
            // {
            //     frequency: 'daily' | 'weekly' | 'monthly' | 'yearly',
            //     interval: 1,
            //     ends_on: 'YYYY-MM-DD' or '',
            //     ends_after: number or '',
            //     on_different_date: false,  // for monthly
            //     every: 'first' | 'second' | 'third' | 'fourth' | 'last' | null,  // for monthly with on_different_date=true
            //     day_in_week: number,  // 0-6 (0=Sunday) for weekly, or day of week for monthly with on_different_date=true
            //                          // OR day of month (1-31) for monthly with on_different_date=false
            // }

            // maybe we need to json parse event.recurrence first
            if (typeof event.recurrence === "string") {
                event.recurrence = JSON.parse(event.recurrence);
            }

            const dtstart = this.moment.tz(
                event.starts_at_local,
                'YYYY-MM-DD HH:mm:ss', // adjust format to your actual value
                'UTC'
            ).toDate();

            let rruleOptions = {
                freq: RRule.DAILY,
                interval: event.recurrence.interval || 1,
                dtstart,
            }

            // Set frequency
            if (event.recurrence.frequency === 'weekly') {
                rruleOptions.freq = RRule.WEEKLY;
            } else if (event.recurrence.frequency === 'monthly') {
                rruleOptions.freq = RRule.MONTHLY;
            } else if (event.recurrence.frequency === 'yearly') {
                rruleOptions.freq = RRule.YEARLY;
            }

            // Set end condition
            if (event.recurrence.ends_after) {
                rruleOptions.count = parseInt(event.recurrence.ends_after);
            }

            if (event.recurrence.ends_on) {
                const until = this.moment.tz(
                    event.recurrence.ends_on + ' 23:59:59', // set to end of day
                    'YYYY-MM-DD HH:mm:ss',
                    'UTC'
                ).toDate();
                rruleOptions.until = until;
            }

            // Weekday mapping: old format (0=Sunday, 1=Monday, etc.) to RRule constants
            const weekdayMap = [
                RRule.SU,  // 0 = Sunday
                RRule.MO,  // 1 = Monday
                RRule.TU,  // 2 = Tuesday
                RRule.WE,  // 3 = Wednesday
                RRule.TH,  // 4 = Thursday
                RRule.FR,  // 5 = Friday
                RRule.SA   // 6 = Saturday
            ];

            // Handle weekly recurrence
            if (event.recurrence.frequency === 'weekly') {
                let weekdays = [];

                // Check if day_in_week is an array (multiple days) or single value
                if (event.recurrence.day_in_week !== undefined && event.recurrence.day_in_week !== null) {
                    if (Array.isArray(event.recurrence.day_in_week)) {
                        // Multiple days
                        weekdays = event.recurrence.day_in_week.map(day => weekdayMap[day]);
                    } else {
                        // Single day
                        weekdays = [weekdayMap[event.recurrence.day_in_week]];
                    }
                }

                if (weekdays.length > 0) {
                    rruleOptions.byweekday = weekdays;
                }
            }

            // Handle monthly recurrence
            if (event.recurrence.frequency === 'monthly') {
                if (event.recurrence.on_different_date === false || event.recurrence.on_different_date === undefined) {
                    // Same date each month - use bymonthday
                    // day_in_week here contains the day of the month (1-31)
                    if (event.recurrence.day_in_week !== undefined && event.recurrence.day_in_week !== null) {
                        rruleOptions.bymonthday = [event.recurrence.day_in_week];
                    } else {
                        // If not specified, use the day from starts_at_local
                        const startDate = new Date(event.starts_at_local);
                        rruleOptions.bymonthday = [startDate.getDate()];
                    }
                } else if (event.recurrence.on_different_date === true) {
                    // Different date - use byweekday and bysetpos (e.g., "first Monday", "last Friday")
                    // day_in_week here contains the day of week (0-6 where 0=Sunday)
                    if (event.recurrence.day_in_week !== undefined && event.recurrence.day_in_week !== null) {
                        rruleOptions.byweekday = [weekdayMap[event.recurrence.day_in_week]];
                    }

                    // Set bysetpos based on 'every' field
                    if (event.recurrence.every) {
                        const everyMap = {
                            'first': 1,
                            'second': 2,
                            'third': 3,
                            'fourth': 4,
                            'last': -1
                        };
                        const everyLower = event.recurrence.every.toLowerCase();
                        if (everyMap[everyLower]) {
                            rruleOptions.bysetpos = everyMap[everyLower];
                        }
                    }
                }
            }

            // Return rrule options object directly (no need to convert to string)
            return rruleOptions;
        },
        setEndsOn(ends_on) {
            // Convert ends_on string to Date object
            if (ends_on && typeof ends_on === 'string') {
                return new Date(ends_on);
            } else if (typeof ends_on === 'object' && ends_on instanceof Date) {
                return ends_on;
            }
            return null;
        },
        // Convert RRule bysetpos value to month number string
        getMonthNumberFromBySetPos(bysetpos) {
            // bysetpos can be an array or single value
            const pos = Array.isArray(bysetpos) ? bysetpos[0] : bysetpos;
            
            const positionMap = {
                1: 'first',
                2: 'second',
                3: 'third',
                4: 'fourth',
                '-1': 'last'
            };

            return positionMap[pos] || 'first';
        },
        // Convert RRule byweekday value to old format day number (0=Sunday, 1=Monday, etc.)
        getMonthDayFromByWeekday(weekday) {
            // weekday can be a Weekday object with .weekday property, or just a number
            let weekdayNum;

            if (typeof weekday === 'object' && weekday.weekday !== undefined) {
                weekdayNum = weekday.weekday;
            } else {
                weekdayNum = weekday;
            }

            // RRule weekday numbering: MO=0, TU=1, WE=2, TH=3, FR=4, SA=5, SU=6
            // Old format: 0=Sunday, 1=Monday, 2=Tuesday, etc.
            // Conversion: RRule SU(6) -> 0, RRule MO(0) -> 1, RRule TU(1) -> 2, etc.

            if (weekdayNum === 6) {
                return 0; // Sunday
            } else {
                return weekdayNum + 1; // Monday-Saturday
            }
        },
        getHeyGovPublicFileUrl(path) {
            return `${process.env.VUE_APP_HEYGOV_FILES}${path}`
        }
    },
    computed: {
        domain() {
            let user = this.getCurrentUser();

            let domain;

            if (user.data.heygov_jurisdiction) {
                domain = user.data.heygov_jurisdiction;
            } else {
                let domainData = localStorage.getObject("site");
                domain = domainData.heygovJurisdiction;
            }

            if (this.getSiteType() == "cms6" && process.env.NODE_ENV != "production") {
                domain = "heyville.org";
            }
            return domain;
        },
        apiKey() {
            let user = this.getCurrentUser();
            let site = localStorage.getObject("site");

            if (user.data.heygov_api_key) {
                return user.data.heygov_api_key;
            } else {
                return site.heygovApiKey;
            }
        },
    },
    mixins: [helperMixin, siteMixin, userMixin],
};
